export enum E_LegendIconType {
    Circle = 'Circle',
    Square = 'Square',
    Triangle = 'Triangle',
    Diamond = 'Diamond',
    Cross = 'Cross',
    Star = 'Star',
    HorizontalLine = 'HorizontalLine',
    VerticalLine = 'VerticalLine',
    DashedLine = 'DashedLine',
    DottedLine = 'DottedLine',
}